"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PATH = exports.MAX_ESTIMATE_REQUEST_SIZE = void 0;
exports.MAX_ESTIMATE_REQUEST_SIZE = 20;
exports.PATH = {
    MEMBER_TERM: '/pages/member-term',
    SERVICE_TERM: '/利用規約'
};
